import React from "react";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";

import { formattedPrice } from "views/pages/manage/unAssigned/collectPayment/utils";
import ALoader from "views/pages/manage/common/a-loader";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
const tableBorderStyle = {
  border: "1px solid rgb(224, 224, 224)",
  borderTop: "none",
  paddingBottom: "10px",
};

const AdjustmentDetailsModal = ({
  groupedData = {
    TRANSFER_OUT: [],
    TRANSFER_IN: [],
  },
  loading,
  transferInBU = "-",
  transferOutBU = "-",
}) => {
  const renderGrid = (items, groupKey) => {
    const isTrout = groupKey === "TRANSFER_OUT";

    const columns = [
      new AGridColDef("itemType", "Item Type", false)
        .setFlex(1.5),
    
      new AGridColDef("description", "Item Description", false)
        .setFlex(2),
    
      new AGridColDef("grossAmount", "Base Amount", false)
        .setFlex(1)
        .columnAlign("right")
        .setValueFormatter(params => formattedPrice(params?.value)),
    
      !isTrout &&
        new AGridColDef("concessionPercent", "Concession (%)", false)
          .setFlex(1)
          .columnAlign("right")
          .setValueGetter(({ row }) => `${row.concessionPercentage || 0}%`),
    
      new AGridColDef("concessionApplied", "Concession Value", false)
        .setFlex(1)
        .columnAlign("right")
        .setValueFormatter(params => formattedPrice(params?.value)),
    
      new AGridColDef("payableAmount", " Net Payable", false)
        .setFlex(1.5)
        .columnAlign("right")
        .setValueFormatter(params => formattedPrice(params?.value)),
    
      new AGridColDef("taxes", "Tax", false)
        .setFlex(0.8)
        .columnAlign("right")
        .setValueFormatter(params => formattedPrice(params?.value)),
    
      new AGridColDef("netPayable", "Payable (Incl. Taxes)", false)
        .setFlex(1)
        .columnAlign("right")
        .setValueFormatter(params => formattedPrice(params?.value)),
    
      isTrout &&
        new AGridColDef("paidAmount", "Paid Amount", false)
          .setFlex(1)
          .columnAlign("right")
          .setValueFormatter(params => formattedPrice(params?.value)),
    
    ].filter(Boolean);
    

    return (
      <div className="mb-4" style={{ minWidth: "1080px" }}>
        <h6 className="fw-bold text-uppercase heading-3 bold-heading-label  text-dark">
          {isTrout ? `TROUT(${transferOutBU})` : `TRIN(${transferInBU})`}
        </h6>
        <div style={tableBorderStyle}>
          <ADataGrid
            rows={items.map((item, index) => ({ id: index, ...item }))}
            columns={columns}
            density="compact"
            className="border rounded"
            hidePagination={true}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="p-3">
      {loading ? (
        <div className="text-center py-4">
          <ALoader size="sm" color="primary" /> Loading...
        </div>
      ) : (
        Object.entries(groupedData).map(([groupKey, items]) =>
          renderGrid(items, groupKey)
        )
      )}
    </div>
  );
};

export default AdjustmentDetailsModal;
